/**
 * APH cart drawer - Dawn-compatible + hardened.
 * Goals: add-to-cart always works, drawer shows items, close always unlocks page.
 */
(function aphKillShipChips() {
  function wipe() {
    document.querySelectorAll('.aph-cart-shipping .aph-tier-chip, .aph-cart-shipping .tier-chip, .aph-cart-shipping .aph-tier-row, .aph-cart-shipping .tier-row, .aph-cart-shipping .aph-fomo-mark, .aph-cart-shipping .aph-fomo-bubble, .aph-cart-shipping .aph-fomo-label, .aph-cart-shipping .aph-fomo-unlock, .aph-cart-shipping .aph-tier-tick').forEach(function (n) {
      n.remove();
    });
    document.querySelectorAll('.aph-cart-shipping--ship, .aph-cart-shipping[data-preset="free_shipping"]').forEach(function (box) {
      box.classList.remove('aph-cart-shipping--payday', 'aph-cart-shipping--fomo');
      box.querySelectorAll('.aph-morning-cap, .aph-morning-label, .aph-fomo-bubble, .aph-fomo-label, .aph-tier-tick, [data-cap], [data-fomo-mark]').forEach(function (n) {
        var t = (n.textContent || '').replace(/\s+/g, ' ').toLowerCase();
        if (
          t.indexOf('30%') !== -1 ||
          t.indexOf('40%') !== -1 ||
          t.indexOf('£50') !== -1 ||
          t.indexOf('£70') !== -1 ||
          t.indexOf('next-day') !== -1 ||
          t.indexOf('nextday') !== -1
        ) {
          n.remove();
        }
      });
      var marks = box.querySelectorAll('.aph-morning-mark, [data-tier-notch], [data-fomo-mark]');
      if (marks.length > 1) {
        for (var i = 0; i < marks.length - 1; i++) marks[i].remove();
      }
      var caps = box.querySelectorAll('.aph-morning-cap, [data-cap]');
      if (caps.length > 1) {
        for (var i = 0; i < caps.length - 1; i++) caps[i].remove();
      }
    });
    document.querySelectorAll('cart-drawer [id*="cart-progress"], cart-drawer [class*="cart-progress"], cart-drawer [class*="CartProgress"]').forEach(function (n) {
      if (n.closest && n.closest('.aph-cart-shipping')) return;
      n.remove();
    });
  }
  wipe();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', wipe);
  document.addEventListener('cart:updated', wipe);
})();
function aphGiftVariantIds() {
  var ids = [];
  try {
    var el = document.getElementById('aph-header-cart-config');
    if (el) {
      var j = JSON.parse(el.textContent);
      if (j && j.gift && j.gift.variantId) ids.push(String(j.gift.variantId));
    }
  } catch (e) {}
  document.querySelectorAll('[data-free-protein-variant]').forEach(function (n) {
    var v = n.getAttribute('data-free-protein-variant');
    if (v) ids.push(String(v));
  });
  return ids;
}
function aphIsGiftLine(item) {
  if (!item) return false;
  var props = item.properties || {};
  if (!Array.isArray(props) && (props._aph_3f2 || props['Three for two'] || props['Buy one get one free'])) return false;
  if (!Array.isArray(props)) {
    if (props._aph_gift || props._free_protein || props['_aph_gift'] || props['_free_protein']) return true;
  } else {
    for (var i = 0; i < props.length; i++) {
      var k = String((props[i] && (props[i].name || props[i][0])) || '');
      if (k === '_aph_gift' || k === '_free_protein') return true;
    }
  }
  var handle = item.handle || '';
  if (handle === 'free-protein-sachet' || handle === 'shilajit-gummies-gift') return true;
  if ((item.product_type || '') === 'Free gift') return true;
  var sku = String(item.sku || '').toUpperCase();
  if (sku.indexOf('APH-GIFT') === 0) return true;
  var title = (item.product_title || item.title || '').toLowerCase();
  if (title.indexOf('free protein sachet') !== -1) return true;
  if (title.indexOf('(gift)') !== -1) return true;
  var id = String(item.variant_id || item.id || '');
  var giftIds = aphGiftVariantIds();
  if (id && giftIds.indexOf(id) !== -1) return true;
  return false;
}
function aphConcreteSale(raw) {
  raw = String(raw || '').trim();
  if (raw === 'none' || raw === 'free_shipping') return raw;
  if (raw === 'PAYDAY30' || raw === 'PAYDAY40' || raw === 'PAYDAY3040') return raw;
  return '';
}
function aphSaleOverride() {
  var header = '';
  var theme = '';
  try {
    var cfgEl = document.getElementById('aph-header-cart-config');
    if (cfgEl) {
      var j = JSON.parse(cfgEl.textContent);
      if (j) {
        header = String(j.headerSale || j.override || '');
        theme = String(j.themeSale || '');
        if (j.saleOn === true || j.saleOn === 'true') {
          if (!window.__aphSaleOnFlag) window.__aphSaleOnFlag = true;
        }
      }
    }
  } catch (e) {}
  var t = aphConcreteSale(theme);
  var h = aphConcreteSale(header);
  var el = document.querySelector('[data-aph-cart-tiers]');
  var fromBar = el
    ? aphConcreteSale(el.getAttribute('data-sale-override') || el.getAttribute('data-sale-mode'))
    : '';
  function isPayday(x) {
    return x === 'PAYDAY30' || x === 'PAYDAY40' || x === 'PAYDAY3040';
  }
  if (isPayday(t)) return t;
  if (isPayday(h)) return h;
  if (isPayday(fromBar)) return fromBar;
  if (t === 'free_shipping' || h === 'free_shipping' || fromBar === 'free_shipping') return 'free_shipping';
  if (t === 'none' || h === 'none' || fromBar === 'none') return 'none';
  if (t) return t;
  if (h) return h;
  if (fromBar) return fromBar;
  if (window.__aphSaleOnFlag) return 'PAYDAY3040';
  return 'follow';
}
function aphMapSpecialPreset(raw) {
  raw = String(raw || '').trim();
  if (raw === 'PAYDAY30' || raw === 'payday30' || raw === 'payday_30') return 'PAYDAY30';
  if (raw === 'PAYDAY40' || raw === 'payday40' || raw === 'payday_40') return 'PAYDAY40';
  if (
    raw === 'PAYDAY3040' ||
    raw === 'PAYDAY30+40' ||
    raw === 'payday' ||
    raw === 'Payday' ||
    raw === 'PAYDAY'
  ) {
    return 'PAYDAY3040';
  }
  if (raw === 'free_shipping' || raw === 'shipping') return 'free_shipping';
  if (raw === 'none') return 'none';
  return '';
}
function aphPickSsSpecial() {
  var now = Date.now() / 1000;
  var best = null;
  var bestSort = 1e9;
  document.querySelectorAll('[data-ss-special]').forEach(function (el) {
    var status = (el.getAttribute('data-status') || 'active').toLowerCase();
    if (status && status !== 'active') return;
    var preset = aphMapSpecialPreset(el.getAttribute('data-preset'));
    if (!preset) return;
    var startRaw = el.getAttribute('data-start');
    var eRaw = el.getAttribute('data-end');
    if ((startRaw === '' || startRaw == null || startRaw === '0') && (eRaw === '' || eRaw == null)) return;
    var s = +(startRaw || 0);
    var e = eRaw === '' || eRaw == null ? Infinity : +eRaw;
    var live = s <= now && now <= e;
    if (!live) return;
    var so = +(el.getAttribute('data-sort') || 9999);
    if (so < bestSort) {
      bestSort = so;
      best = {
        preset: preset,
        hideQty: el.getAttribute('data-hide-qty') === '1',
        sort: so,
      };
    }
  });
  return best;
}
function aphSaleMode() {
  /* Follow live scheduler payday, else customizer. */
  var ss = typeof aphPickSsSpecial === 'function' ? aphPickSsSpecial() : null;
  if (ss && (ss.preset === 'PAYDAY30' || ss.preset === 'PAYDAY40' || ss.preset === 'PAYDAY3040')) {
    return ss.preset;
  }
  var raw = aphSaleOverride();
  if (raw === 'PAYDAY30' || raw === 'PAYDAY40' || raw === 'PAYDAY3040') return raw;
  if (raw === 'none' || raw === 'free_shipping') return raw;
  return 'none';
}
function aphSaleIsPayday(mode) {
  mode = mode || aphSaleMode();
  return mode === 'PAYDAY30' || mode === 'PAYDAY40' || mode === 'PAYDAY3040';
}
function aphSaleOn() {
  var mode = aphSaleMode();
  if (mode !== 'none' && mode !== 'free_shipping') return true;
  try {
    var html = document.documentElement;
    if (html.getAttribute('data-aph-hide-qty') === 'true') return true;
    var sale = html.getAttribute('data-aph-sale') || '';
    if (sale && sale !== 'none' && sale !== 'free_shipping') return true;
  } catch (e) {}
  return false;
}
function aphSalePaidPence() {
  var el = document.querySelector('[data-aph-cart-tiers]');
  if (el) return parseInt(el.getAttribute('data-tier-paid') || '0', 10) || 0;
  return 0;
}
function aphSaleDiscountCode() {
  var mode = aphSaleMode();
  var paid = aphSalePaidPence();
  if (mode === 'PAYDAY30') return paid >= 5000 ? 'PAYDAY30' : '';
  if (mode === 'PAYDAY40') return paid >= 8000 ? 'PAYDAY40' : '';
  if (mode === 'PAYDAY3040') {
    if (paid >= 8000) return 'PAYDAY40';
    if (paid >= 5000) return 'PAYDAY30';
    return '';
  }
  return '';
}
function aphApplySaleHtml() {
  var mode = aphSaleMode();
  document.documentElement.setAttribute('data-aph-sale', mode);
  var hide = mode !== 'none' && mode !== 'free_shipping';
  document.documentElement.setAttribute('data-aph-hide-qty', hide ? 'true' : 'false');
}
function aphBulkLineCents(item) {
  if (!item || aphIsGiftLine(item)) return 0;
  var final = Number(item.final_line_price) || 0;
  if (final === 0) return 0;
  /* Sale on: never theme 10/15% bulk. Line = qty x Shopify unit. */
  if (aphSaleOn()) return final;
  var orig = Number(item.original_line_price) || final;
  var q = Number(item.quantity) || 0;
  if (orig !== final) return final;
  var pct = q >= 3 ? 15 : q >= 2 ? 10 : 0;
  if (!pct) return final;
  return Math.round((orig * (100 - pct)) / 100);
}
function aphStripBulkWhenSale(cart) {
  if (!aphSaleOn()) return;
  var map = {};
  (cart && cart.items ? cart.items : []).forEach(function (it) {
    if (!it || aphIsGiftLine(it)) return;
    if (it.key) map['k:' + String(it.key)] = it;
    if (it.variant_id) map['v:' + String(it.variant_id)] = it;
  });
  document.querySelectorAll('cart-drawer .cart-item, cart-drawer-items .cart-item, #main-cart-items .cart-item').forEach(function (row) {
    if (row.getAttribute('data-aph-gift')) return;
    var save = row.querySelector('.cart-item__bulk-save');
    if (save) save.remove();
    var old = row.querySelector('.cart-item__old-price');
    if (old) old.remove();
    var input = row.querySelector('[data-quantity-line-key], [data-quantity-variant-id]');
    var it = null;
    if (input) {
      it = map['k:' + String(input.getAttribute('data-quantity-line-key') || '')] ||
        map['v:' + String(input.getAttribute('data-quantity-variant-id') || '')];
    }
    if (!it) return;
    var priceEl = row.querySelector('.cart-item__line-price');
    if (!priceEl) return;
    var pounds = (Number(it.final_line_price) || 0) / 100;
    priceEl.setAttribute('data-gbp', pounds.toFixed(2));
    priceEl.textContent = '£' + pounds.toFixed(2);
  });
  if (window.APH && typeof window.APH.applyCurrency === 'function') {
    try { window.APH.applyCurrency(); } catch (e) {}
  }
}
function aphPaidItemCount(state) {
  if (!state) return 0;
  var items = state.items;
  if (!Array.isArray(items)) return state.item_count || 0;
  var n = 0;
  items.forEach(function (item) {
    if (aphIsGiftLine(item)) return;
    if ((item.final_line_price || 0) === 0) return;
    n += Number(item.quantity) || 0;
  });
  return n;
}
function aphCartHasLines(state) {
  if (!state) return false;
  var items = state.items;
  if (!Array.isArray(items)) return (state.item_count || 0) > 0;
  for (var i = 0; i < items.length; i++) {
    if (!aphIsGiftLine(items[i])) return true;
  }
  return false;
}
function aphApplyDrawerEmpty(drawer, cart) {
  if (!drawer) return;
  var empty = !aphCartHasLines(cart);
  drawer.classList.toggle('is-empty', empty);
  var itemsEl = drawer.querySelector('cart-drawer-items');
  if (itemsEl) itemsEl.classList.toggle('is-empty', empty);
  var header = drawer.querySelector('.drawer__header');
  if (header) {
    if (empty) header.setAttribute('hidden', '');
    else header.removeAttribute('hidden');
  }
  var emptyBox = drawer.querySelector('.drawer__inner-empty');
  if (emptyBox) {
    emptyBox.hidden = !empty;
    emptyBox.style.display = empty ? '' : 'none';
  }
}
function aphCartRoot() {
  return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
}
function aphCartJsUrl() {
  return aphCartRoot() + 'cart.js?_ts=' + Date.now();
}
/* No-op update so Shopify returns live cart + section HTML. GET /cart?section_id=
   can stay empty after ATC / Woo back while cart.js already has lines. */
function aphFetchCartWithSections() {
  var root = aphCartRoot();
  return fetch(root + 'cart/update.js', {
    method: 'POST',
    credentials: 'same-origin',
    cache: 'no-store',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
    body: JSON.stringify({
      updates: {},
      sections: 'cart-drawer,cart-icon-bubble',
      sections_url: root + 'cart',
    }),
  }).then(function (r) {
    if (!r.ok) throw new Error('cart/update ' + r.status);
    return r.json();
  });
}
function aphSectionHasCartRows(doc) {
  if (!doc) return false;
  return !!(
    doc.querySelector('#CartDrawer-CartItems .cart-item') ||
    doc.querySelector('.drawer__cart-items-wrapper .cart-item') ||
    doc.querySelector('cart-drawer-items .cart-item')
  );
}
function aphApplyCartDrawerHtml(drawer, html, cart) {
  if (!drawer || !html) return false;
  var doc = new DOMParser().parseFromString(html, 'text/html');
  var has = aphCartHasLines(cart);
  var hasRows = aphSectionHasCartRows(doc);
  if (has && !hasRows) {
    aphApplyDrawerEmpty(drawer, cart);
    return false;
  }
  var wasOpen = drawer.classList.contains('active') || drawer.hasAttribute('open');
  var nextInner = doc.querySelector('#CartDrawer');
  var live = document.getElementById('CartDrawer') || drawer.querySelector('#CartDrawer');
  if (live && nextInner) {
    live.innerHTML = nextInner.innerHTML;
  } else {
    var nextHost = doc.querySelector('cart-drawer');
    if (!nextHost) return false;
    drawer.innerHTML = nextHost.innerHTML;
  }
  aphApplyDrawerEmpty(drawer, cart);
  if (typeof drawer._bindChrome === 'function') drawer._bindChrome();
  if (window.APH && typeof window.APH.applyCurrency === 'function') {
    try { window.APH.applyCurrency(); } catch (e) {}
  }
  if (wasOpen) {
    drawer.classList.add('active', 'animate');
    drawer.setAttribute('open', '');
    drawer.style.pointerEvents = 'auto';
  }
  return true;
}
window.APH = window.APH || {};
window.APH.paidItemCount = aphPaidItemCount;
window.APH.bulkLineCents = aphBulkLineCents;
window.APH.stripBulkWhenSale = aphStripBulkWhenSale;

/* Leftover BXGY £0 same-SKU row: fold its qty into the paid line, then
   drop the £0 row. Buy 3 must stay qty 3, not become qty 2. */
window.APH.stripBxgyZeroExtras = function stripBxgyZeroExtras() {
  var cartUrl = ((window.routes && window.routes.cart_url) || '/cart') + '.js';
  var updateUrl = (window.routes && window.routes.cart_update_url) || '/cart/update.js';
  return fetch(cartUrl, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
    .then(function (r) {
      return r.json();
    })
    .then(function (cart) {
      var items = (cart && cart.items) || [];
      var paid = {};
      var updates = {};
      var changed = false;
      items.forEach(function (it) {
        if (aphIsGiftLine(it)) return;
        if ((it.final_line_price || 0) <= 0) return;
        var vid = String(it.variant_id);
        if (!paid[vid]) {
          paid[vid] = { key: it.key, qty: Number(it.quantity) || 0 };
        } else {
          paid[vid].qty += Number(it.quantity) || 0;
          updates[it.key] = 0;
          updates[paid[vid].key] = paid[vid].qty;
          changed = true;
        }
      });
      items.forEach(function (it) {
        if (aphIsGiftLine(it)) return;
        if ((it.final_line_price || 0) !== 0) return;
        var p = paid[String(it.variant_id)];
        if (!p) return;
        p.qty += Number(it.quantity) || 0;
        updates[it.key] = 0;
        updates[p.key] = p.qty;
        changed = true;
      });
      if (!changed) return false;
      return fetch(updateUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({ updates: updates }),
      }).then(function (r) {
        return r.json();
      }).then(function () {
        return true;
      });
    })
    .catch(function (err) {
      console.warn('[APH] stripBxgyZeroExtras', err);
    });
};
window.APH.stripThreeForTwoExtras = window.APH.stripBxgyZeroExtras;

/* Repaint drawer + /cart + badge from fresh section HTML without opening
   the drawer. Runs after a merge so already-split carts heal on load. */
window.APH.refreshCartDom = function refreshCartDom(cartHint) {
  var drawer = document.querySelector('cart-drawer');
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var cartP = cartHint
    ? Promise.resolve(cartHint)
    : fetch(aphCartJsUrl(), {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
        cache: 'no-store',
      }).then(function (r) {
        return r.json();
      });
  return cartP.then(function (cart) {
    window.__aphLastCart = cart;
    if (drawer && typeof drawer._updateCartIcon === 'function') drawer._updateCartIcon(null, cart);
    aphApplyDrawerEmpty(drawer, cart);
    var jobs = [];
    if (drawer && typeof drawer._fetchSection === 'function') {
      jobs.push(
        drawer._fetchSection('cart-drawer').then(function (html) {
          if (aphApplyCartDrawerHtml(drawer, html, cart)) return;
          if (!aphCartHasLines(cart)) return;
          return drawer._fetchSection('cart-drawer').then(function (html2) {
            aphApplyCartDrawerHtml(drawer, html2, cart);
          });
        })
      );
    }
    if (document.getElementById('main-cart-items')) {
      jobs.push(
        fetch(root + 'cart?section_id=main-cart-items&_ts=' + Date.now(), {
          credentials: 'same-origin',
          cache: 'no-store',
        })
          .then(function (r) {
            return r.text();
          })
          .then(function (txt) {
            var doc = new DOMParser().parseFromString(txt, 'text/html');
            var src = doc.querySelector('cart-items');
            var liveEl = document.querySelector('#main-cart-items cart-items');
            if (src && liveEl) liveEl.innerHTML = src.innerHTML;
            if (window.APH && typeof window.APH.applyCurrency === 'function') {
              try {
                window.APH.applyCurrency();
              } catch (e) {}
            }
          })
      );
    }
    return Promise.all(jobs).then(function () {
      aphApplyDrawerEmpty(drawer, cart);
      return cart;
    });
  });
};

window.APH.resyncCartFromServer = function resyncCartFromServer(opts) {
  opts = opts || {};
  if (!opts.force && window.APH._resyncInFlight) return window.APH._resyncInFlight;
  var run = aphFetchCartWithSections()
    .then(function (data) {
      var cart = data;
      window.__aphLastCart = cart;
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer._updateCartIcon === 'function') {
        drawer._updateCartIcon(null, cart);
      }
      aphApplyDrawerEmpty(drawer, cart);
      var html = data && data.sections && data.sections['cart-drawer'];
      if (html && aphApplyCartDrawerHtml(drawer, html, cart)) {
        if (data.sections['cart-icon-bubble'] && typeof drawer._updateCartIcon === 'function') {
          drawer._updateCartIcon(data.sections['cart-icon-bubble'], cart);
        }
        aphApplyDrawerEmpty(drawer, cart);
        return cart;
      }
      return window.APH.refreshCartDom(cart);
    })
    .catch(function () {
      return window.APH.refreshCartDom();
    })
    .catch(function (err) {
      console.warn('[APH] resyncCartFromServer', err);
    })
    .finally(function () {
      if (window.APH._resyncInFlight === run) window.APH._resyncInFlight = null;
    });
  window.APH._resyncInFlight = run;
  return run;
};

class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this._onKeyUp = (evt) => {
      if (evt.code === 'Escape' || evt.key === 'Escape') this.close();
    };
    this._eventInsideDrawer = (evt) => {
      const path = typeof evt.composedPath === 'function' ? evt.composedPath() : [];
      for (let i = 0; i < path.length; i++) {
        const n = path[i];
        if (!n || !n.classList) continue;
        if (n === this) return true;
        if (n.classList.contains('drawer__inner')) return true;
        if (n.classList.contains('aph-inline-confirm')) return true;
        if (n.tagName === 'CART-REMOVE-BUTTON') return true;
      }
      return this.contains(evt.target);
    };
    this._onOverlayClick = (evt) => {
      if (this._updating) return;
      if (evt) {
        evt.preventDefault();
        evt.stopPropagation();
      }
      /* Scrim is never inside the panel - always close. (Old _eventInsideDrawer
         check returned true here because the host is in the composed path,
         which killed blur-click-to-close.) */
      this.close();
    };
    // Click scrim / host (not panel) closes - covers overlay + any transparent host area
    this._onHostClick = (evt) => {
      if (this._updating) return;
      if (!this.classList.contains('active') && !this.hasAttribute('open')) return;
      const panel = this.querySelector('.drawer__inner');
      if (panel && panel.contains(evt.target)) return;
      this.close();
    };
    this._onDocClickAway = (evt) => {
      if (!this.classList.contains('active') && !this.hasAttribute('open')) return;
      if (this._eventInsideDrawer(evt)) return;
      if (this.contains(evt.target)) return;
      this.close();
    };
    this.addEventListener('keyup', this._onKeyUp);
    this.addEventListener('click', this._onHostClick);
    this._bindChrome();
    // Header renders AFTER cart-drawer in theme.liquid - bind when icon exists
    this.setHeaderCartIconAccessibility();
    this._scheduleHeaderBind();
  }

  connectedCallback() {
    this._bindChrome();
    this._scheduleHeaderBind();
  }

  _scheduleHeaderBind() {
    if (this._headerBindScheduled) return;
    this._headerBindScheduled = true;
    let tries = 0;
    const tryBind = () => {
      this.setHeaderCartIconAccessibility();
      const link = document.querySelector('#cart-icon-bubble');
      if (link && link.dataset.cartDrawerBound === '1') return;
      tries += 1;
      if (tries < 120) requestAnimationFrame(tryBind);
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', tryBind, { once: true });
    } else {
      tryBind();
    }
    window.addEventListener('load', () => this.setHeaderCartIconAccessibility(), { once: true });
  }

  _bindChrome() {
    const overlay = this.querySelector('#CartDrawer-Overlay') || this.querySelector('.cart-drawer__overlay');
    if (overlay) {
      overlay.removeEventListener('click', this._onOverlayClick);
      overlay.addEventListener('click', this._onOverlayClick);
    }
    this.querySelectorAll('.drawer__close').forEach((btn) => {
      if (btn.dataset.aphBound === '1') return;
      btn.dataset.aphBound = '1';
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.close();
      });
    });
  }

  setHeaderCartIconAccessibility() {
    document.querySelectorAll('#cart-icon-bubble, a.icon-btn[aria-label="Cart"]').forEach((cartLink) => {
      if (!cartLink || cartLink.dataset.cartDrawerBound === '1') return;
      cartLink.dataset.cartDrawerBound = '1';
      cartLink.setAttribute('role', 'button');
      cartLink.setAttribute('aria-haspopup', 'dialog');
      cartLink.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (this.classList.contains('active')) this.close();
        else this.open(cartLink);
      });
      cartLink.addEventListener('keydown', (event) => {
        const code = (event.code || '').toUpperCase();
        if (code === 'SPACE' || code === 'ENTER') {
          event.preventDefault();
          this.open(cartLink);
        }
      });
    });
  }

  open(triggeredBy) {
    var bag = document.querySelector(
      '#cart-icon-bubble .bag-count, #cart-icon-bubble .cart-count, #cart-icon-bubble .cart-count-bubble'
    );
    var bagN = bag ? parseInt((bag.textContent || '').replace(/[^\d]/g, ''), 10) : 0;
    if (bagN > 0) {
      this.classList.remove('is-empty');
      var itemsEl = this.querySelector('cart-drawer-items');
      if (itemsEl) itemsEl.classList.remove('is-empty');
      var header = this.querySelector('.drawer__header');
      if (header) header.removeAttribute('hidden');
      var emptyBox = this.querySelector('.drawer__inner-empty');
      if (emptyBox) {
        emptyBox.hidden = true;
        emptyBox.style.display = 'none';
      }
    }
    if (window.APH && typeof window.APH.resyncCartFromServer === 'function') {
      window.APH.resyncCartFromServer({ force: true }).catch(function () {});
    }
    try {
      if (triggeredBy) this.setActiveElement(triggeredBy);
      // Two-frame open so translateX slide (not snap) paints closed state first
      this.classList.add('animate', 'active');
      this.setAttribute('open', '');
      this.setAttribute('aria-hidden', 'false');
      this.style.pointerEvents = 'auto';
      document.body.classList.add('overflow-hidden');
      document.documentElement.classList.add('cart-drawer-open');
      this._bindChrome();
      // Document click-away (next tick so open click does not immediately close)
      document.removeEventListener('click', this._onDocClickAway, true);
      setTimeout(() => {
        document.addEventListener('click', this._onDocClickAway, true);
      }, 0);
      // reflow then keep active (double-rAF for paint); never rely on rAF alone
      requestAnimationFrame(() => {
        this.classList.add('active');
        requestAnimationFrame(() => {
          this.classList.add('active');
        });
      });

      // Soft focus - never hard-trap (trapFocus left page unusable when it failed)
      requestAnimationFrame(() => {
        const focusEl =
          this.querySelector('.drawer__close') ||
          this.querySelector('.drawer__inner') ||
          this.querySelector('#CartDrawer');
        if (focusEl && typeof focusEl.focus === 'function') {
          try {
            focusEl.focus({ preventScroll: true });
          } catch (e) {
            try {
              focusEl.focus();
            } catch (e2) {}
          }
        }
      });

      try {
        this.querySelector('cart-drawer-items')?.dispatchViewEvent?.();
      } catch (e) {}
    } catch (e) {
      console.warn('[cart-drawer] open failed', e);
      this.close();
    }
  }

  close() {
    this.classList.remove('active', 'animate');
    this.removeAttribute('open');
    this.setAttribute('aria-hidden', 'true');
    this.style.pointerEvents = 'none';
    document.body.classList.remove('overflow-hidden');
    document.documentElement.classList.remove('cart-drawer-open');
    document.removeEventListener('click', this._onDocClickAway, true);
    try {
      if (typeof removeTrapFocus === 'function' && this.activeElement) {
        removeTrapFocus(this.activeElement);
      }
    } catch (e) {}
  }

  getSectionsToRender() {
    return [
      { id: 'cart-drawer', section: 'cart-drawer', selector: '#CartDrawer' },
      { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' },
    ];
  }

  getSectionInnerHTML(html, selector) {
    if (!html) return '';
    try {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const el = selector ? doc.querySelector(selector) : doc.querySelector('.shopify-section') || doc.body;
      return el ? el.innerHTML : '';
    } catch (e) {
      return '';
    }
  }

  async renderContents(parsedState) {
    const state = parsedState || {};
    try {
      if (window.APH && typeof window.APH.stripBxgyZeroExtras === 'function') {
        await window.APH.stripBxgyZeroExtras();
      }
    } catch (e) {}
    let sections = {};
    try {
      const html = await this._fetchSection('cart-drawer');
      if (html) sections['cart-drawer'] = html;
      const icon = await this._fetchSection('cart-icon-bubble');
      if (icon) sections['cart-icon-bubble'] = icon;
    } catch (e) {
      console.warn('[cart-drawer] section fetch failed', e);
    }

    this._updating = true;
    this.classList.add('aph-cart-no-anim');
    // Always clear empty flag after a successful add path
    this.classList.remove('is-empty');

    // --- Drawer body (Dawn pattern: replace #CartDrawer innerHTML) ---
    const drawerHtml = sections['cart-drawer'];
    if (drawerHtml) {
      try {
        var cartState = state.items ? state : window.__aphLastCart;
        if (!aphApplyCartDrawerHtml(this, drawerHtml, cartState)) {
          this.classList.remove('is-empty');
        }
      } catch (e) {
        console.warn('[cart-drawer] drawer HTML apply failed', e);
        this.classList.remove('is-empty');
      }
    } else {
      this.classList.remove('is-empty');
    }

    // --- Bag count (keep APH SVG; only swap count bubble) ---
    this._updateCartIcon(sections['cart-icon-bubble'], null);

    // Rebind after DOM replace
    this.querySelectorAll('.drawer__close').forEach((btn) => {
      delete btn.dataset.aphBound;
    });
    this._bindChrome();

    if (window.APH && typeof window.APH.stripBulkWhenSale === 'function') {
      try { window.APH.stripBulkWhenSale(state); } catch (e) {}
    }
    if (window.APH && typeof window.APH.syncCartTiersAndGift === 'function') {
      window.APH.syncCartTiersAndGift({ openDrawer: false, fromRender: true }).catch(() => {});
    }

    setTimeout(() => {
      this.open(document.getElementById('cart-icon-bubble'));
      this.classList.remove('aph-cart-no-anim');
      this._updating = false;
    }, 10);
  }

  _updateCartIcon(html, parsedState) {
    const bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return;

    let count = null;
    if (parsedState && Array.isArray(parsedState.items)) {
      count = String(aphPaidItemCount(parsedState));
    } else {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root + 'cart.js?_ts=' + Date.now(), {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
        cache: 'no-store',
      })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) {
          if (!cart) return;
          this._updateCartIcon(null, cart);
        }.bind(this))
        .catch(function () {});
      return;
    }

    let badge = bubble.querySelector('.bag-count, .cart-count, .cart-count-bubble');
    if (count && count !== '0') {
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'bag-count cart-count';
        badge.setAttribute('aria-hidden', 'true');
        bubble.appendChild(badge);
      }
      badge.classList.add('bag-count', 'cart-count');
      if (badge.classList.contains('cart-count-bubble')) {
        const s = badge.querySelector('span[aria-hidden="true"]') || badge.querySelector('span');
        if (s) s.textContent = count;
        else badge.textContent = count;
      } else {
        badge.textContent = count;
      }
    } else if (badge && count === '0') {
      badge.remove();
    }
  }

  _fetchSection(sectionId) {
    const root = aphCartRoot();
    const ts = Date.now();
    if (sectionId === 'cart-drawer') {
      return aphFetchCartWithSections()
        .then(function (data) {
          if (data && data.items) window.__aphLastCart = data;
          var html = data && data.sections && data.sections['cart-drawer'];
          if (html && html.indexOf('CartDrawer') !== -1) return html;
          throw new Error('no drawer html');
        })
        .catch(function () {
          return fetch(root + 'cart?section_id=cart-drawer&_ts=' + ts, {
            credentials: 'same-origin',
            cache: 'no-store',
          })
            .then((r) => (r.ok ? r.text() : ''))
            .then((html) => {
              if (html && html.indexOf('CartDrawer') !== -1) return html;
              return fetch(root + 'cart?sections=cart-drawer&_ts=' + ts, {
                headers: { Accept: 'application/json' },
                credentials: 'same-origin',
                cache: 'no-store',
              })
                .then((r) => (r.ok ? r.json() : null))
                .then((data) => (data && data[sectionId]) || null);
            });
        })
        .catch(() => null);
    }
    return fetch(root + '?sections=' + encodeURIComponent(sectionId) + '&_ts=' + ts, {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
      cache: 'no-store',
    })
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => (data && data[sectionId]) || null)
      .catch(() => null);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  setSummaryAccessibility(cartDrawerNote) {
    if (!cartDrawerNote) return;
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');
  }
}

if (!customElements.get('cart-drawer')) {
  customElements.define('cart-drawer', CartDrawer);
}

// cart-drawer-items extends CartItems when available
function registerCartDrawerItems() {
  try {
    if (typeof CartItems === 'undefined') return false;
    if (customElements.get('cart-drawer-items')) return true;
    class CartDrawerItems extends CartItems {
      getSectionsToRender() {
        return [
          { id: 'CartDrawer', section: 'cart-drawer', selector: '.drawer__inner' },
          { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' },
        ];
      }
    }
    customElements.define('cart-drawer-items', CartDrawerItems);
    return true;
  } catch (e) {
    console.warn('[cart-drawer] CartDrawerItems', e);
    return false;
  }
}
if (!registerCartDrawerItems()) {
  let tries = 0;
  const t = setInterval(() => {
    tries += 1;
    if (registerCartDrawerItems() || tries > 40) clearInterval(t);
  }, 100);
}

/* ---------- Global helpers ---------- */
window.APH = window.APH || {};

window.APH.unlockPage = function unlockPage() {
  document.body.classList.remove('overflow-hidden');
  document.documentElement.classList.remove('cart-drawer-open');
  document.body.style.overflow = '';
  const d = document.querySelector('cart-drawer');
  if (d) {
    d.classList.remove('active', 'animate');
    d.removeAttribute('open');
    d.setAttribute('aria-hidden', 'true');
    d.style.pointerEvents = 'none';
  }
};

window.APH.openCartDrawer = function openCartDrawer(parsedState) {
  const drawer = document.querySelector('cart-drawer');
  if (!drawer) {
    window.location.href = (window.routes && window.routes.cart_url) || '/cart';
    return Promise.resolve();
  }
  if (parsedState && typeof drawer.renderContents === 'function') {
    return Promise.resolve(drawer.renderContents(parsedState)).catch((e) => {
      console.warn('[APH] renderContents', e);
      drawer.open && drawer.open(document.getElementById('cart-icon-bubble'));
    });
  }
  if (typeof drawer.open === 'function') drawer.open(document.getElementById('cart-icon-bubble'));
  return Promise.resolve();
};

/**
 * Robust add-to-cart.
 * Prefer JSON body (reliable sections). FormData still supported.
 */
window.APH.addToCart = function addToCart(formOrData) {
  const sections = ['cart-drawer', 'cart-icon-bubble'];
  const sectionsUrl = window.location.pathname || '/';
  const addUrl = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';

  let body;
  let headers = {
    Accept: 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  };

  // Parse id + qty from FormData or plain object
  function parseVariant(src) {
    let id;
    let quantity = 1;
    if (typeof FormData !== 'undefined' && src instanceof FormData) {
      id = src.get('id') || src.get('items[0][id]');
      quantity = parseInt(src.get('quantity') || src.get('items[0][quantity]') || '1', 10) || 1;
    } else if (src && typeof src === 'object') {
      if (src.items && src.items[0]) {
        id = src.items[0].id;
        quantity = parseInt(src.items[0].quantity, 10) || 1;
      } else {
        id = src.id;
        quantity = parseInt(src.quantity, 10) || 1;
      }
    }
    id = parseInt(id, 10);
    if (!id) throw new Error('Missing variant id');
    return { id: id, quantity: Math.max(1, Math.min(99, quantity)) };
  }

  let variant;
  try {
    variant = parseVariant(formOrData);
  } catch (e) {
    return Promise.reject(e);
  }

  // Dawn-style: FormData with id + quantity + sections (best section HTML support)
  const fd = new FormData();
  fd.set('id', String(variant.id));
  fd.set('quantity', String(variant.quantity));
  fd.set('sections', sections.join(','));
  fd.set('sections_url', sectionsUrl);
  body = fd;
  // Do not set Content-Type - browser sets multipart boundary

  function isCartError(r, data) {
    if (!r.ok) return true;
    if (!data) return true;
    // Shopify error: { status, message, description }
    if (data.status && data.message && !data.key && !data.product_id && !(data.items && data.items.length)) {
      return true;
    }
    return false;
  }

  function normalizeState(state) {
    if (state && state.items && state.items[0] && !state.quantity) {
      state.quantity = state.items[0].quantity;
      state.id = state.items[0].id;
      state.key = state.items[0].key;
      state.title = state.items[0].title;
    }
    return state;
  }

  return fetch(addUrl, { method: 'POST', headers: headers, body: body })
    .then((r) =>
      r.json().then((data) => {
        if (isCartError(r, data)) {
          window.APH.unlockPage();
          throw data;
        }
        return normalizeState(data);
      })
    )
    .then((state) => {
      var strip =
        window.APH && typeof window.APH.stripBxgyZeroExtras === 'function'
          ? window.APH.stripBxgyZeroExtras()
          : Promise.resolve();
      return Promise.resolve(strip).then(() => window.APH.openCartDrawer(state).then(() => state));
    })
    .catch((err) => {
      // Retry once with JSON single-variant body if FormData path failed hard
      if (err && err.status) {
        window.APH.unlockPage();
        throw err;
      }
      return fetch(addUrl, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({
          id: variant.id,
          quantity: variant.quantity,
          sections: sections.join(','),
          sections_url: sectionsUrl,
        }),
      })
        .then((r) =>
          r.json().then((data) => {
            if (isCartError(r, data)) {
              window.APH.unlockPage();
              throw data;
            }
            return normalizeState(data);
          })
        )
        .then((state) => {
          var strip =
            window.APH && typeof window.APH.stripBxgyZeroExtras === 'function'
              ? window.APH.stripBxgyZeroExtras()
              : Promise.resolve();
          return Promise.resolve(strip).then(() => window.APH.openCartDrawer(state).then(() => state));
        })
        .catch((err2) => {
          window.APH.unlockPage();
          throw err2;
        });
    });
};

// Escape recovery (capture phase)
document.addEventListener(
  'keydown',
  (e) => {
    if (e.key === 'Escape' || e.code === 'Escape') {
      const d = document.querySelector('cart-drawer');
      if (d && d.classList.contains('active') && typeof d.close === 'function') d.close();
      else window.APH.unlockPage();
    }
  },
  true
);

// Watchdog: body locked without an open drawer/menu/search
function aphCartLockWatchdog() {
  if (!document.body.classList.contains('overflow-hidden')) return;
  const drawerOpen = document.querySelector('cart-drawer.active, cart-drawer[open]');
  const menuOpen =
    document.body.classList.contains('menu-open') || document.documentElement.classList.contains('menu-open');
  const searchOpen = document.querySelector('[data-search-drawer].open, .search-drawer.open');
  if (!drawerOpen && !menuOpen && !searchOpen) window.APH.unlockPage();
}
setInterval(aphCartLockWatchdog, 800);
document.addEventListener('pageshow', aphCartLockWatchdog);

// Ensure APH ATC is available even if this file loaded late
document.addEventListener('shopify:section:load', () => {
  const d = document.querySelector('cart-drawer');
  if (d && typeof d.setHeaderCartIconAccessibility === 'function') d.setHeaderCartIconAccessibility();
  if (d && typeof d._bindChrome === 'function') d._bindChrome();
});

/**
 * Free protein gift + tier bar sync.
 * Auto-adds £0 free-protein-sachet when paid cart ≥ £65; removes below.
 * Thresholds: protein £65 / ship £100 / next-day £150 (settings, pence).
 * Cart total for tiers EXCLUDES free-gift lines.
 */
(function aphCartTiersAndGift() {
  const root = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  let syncing = false;
  let pendingRerun = false;
  let lastOpen = false;

  function moneyFromPence(p) {
    var pounds = Math.max(0, Number(p) || 0) / 100;
    if (Math.abs(pounds - Math.round(pounds)) < 0.005) {
      return '£' + String(Math.round(pounds));
    }
    if (window.APH && typeof window.APH.formatPrice === 'function') {
      return window.APH.formatPrice(pounds);
    }
    return '£' + pounds.toFixed(2);
  }
  function moneyBFromPence(p) {
    var pounds = Math.max(0, Number(p) || 0) / 100;
    return '<b class="cur-price" data-gbp="' + pounds.toFixed(2) + '">' + moneyFromPence(p) + '</b>';
  }
  function paintChipAmounts(box, cfg) {
    if (!box) return;
    var payday = cfg.preset === 'payday_30';
    var amounts = payday ? [cfg.t1, cfg.t2] : [cfg.t1, cfg.t2, cfg.t3];
    amounts.forEach(function (th, i) {
      var chip = box.querySelector('[data-tier-chip="' + (i + 1) + '"]');
      var b = chip && chip.querySelector('b');
      if (!b) return;
      var gbp = Math.max(0, Number(th) || 0) / 100;
      b.setAttribute('data-gbp', gbp.toFixed(2));
      b.classList.add('cur-price');
      b.textContent = moneyFromPence(th);
    });
  }

  function readHeaderCart() {
    const el = document.getElementById('aph-header-cart-config');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function readConfig() {
    const el = document.querySelector('[data-aph-cart-tiers]');
    const mode = aphSaleMode();
    let preset = 'none';
    if (mode === 'PAYDAY30' || mode === 'PAYDAY40' || mode === 'PAYDAY3040') preset = 'payday_30';
    else if (mode === 'free_shipping') preset = 'free_shipping';
    let t1 = parseInt((el && el.getAttribute('data-tier-protein')) || '6500', 10) || 6500;
    let t2 = parseInt((el && el.getAttribute('data-tier-shipping')) || '10000', 10) || 10000;
    let t3 = parseInt((el && el.getAttribute('data-tier-nextday')) || '15000', 10) || 15000;
    if (preset === 'payday_30') {
      t1 = 5000;
      t2 = 8000;
      t3 = 8000;
    }
    const header = readHeaderCart();
    let giftVid = '';
    let giftMin = t1;
    let giftKind = 'free_protein';
    /* Gift off this unit. Shipping only. Do not auto-add a free SKU. */
    giftVid = '';
    return {
      preset: preset,
      t1: t1,
      t2: t2,
      t3: t3,
      freeVid: giftVid,
      giftMin: giftMin,
      giftKind: giftKind,
      giftName: 'free shipping',
      headerUpsells: (header && header.upsells) || [],
    };
  }

  function isGiftItem(item) {
    if (!item) return false;
    const props = item.properties || {};
    if (props._aph_gift || props._free_protein) return true;
    if (item.handle === 'free-protein-sachet' || item.handle === 'shilajit-gummies-gift') return true;
    if ((item.product_type || '') === 'Free gift') return true;
    const sku = String(item.sku || '').toUpperCase();
    if (sku.indexOf('APH-GIFT') === 0) return true;
    const title = (item.product_title || item.title || '').toLowerCase();
    if (title.indexOf('free protein sachet') !== -1) return true;
    if (title.indexOf('(gift)') !== -1) return true;
    const cfg = readConfig();
    if (cfg.freeVid && String(item.variant_id) === cfg.freeVid && (item.final_line_price || 0) === 0) return true;
    return false;
  }

  function paidSubtotal(cart) {
    let paid = 0;
    (cart.items || []).forEach((item) => {
      if (isGiftItem(item)) return;
      paid += typeof aphBulkLineCents === 'function' ? aphBulkLineCents(item) : item.final_line_price || 0;
    });
    return paid;
  }

  function findGiftLine(cart) {
    return (cart.items || []).find((item) => isGiftItem(item)) || null;
  }

  function updateTierDom(paid, cfg) {
    /* Harry 2026-08-08: search drawer now renders its own aph-cart-tiers
       instance for freebie parity with the cart drawer - update every
       instance found, not just the first (querySelector) one. */
    document.querySelectorAll('[data-aph-cart-tiers]').forEach((box) => {
      updateOneTierBox(box, paid, cfg);
    });
    document.querySelectorAll('[data-aph-gift-banner]').forEach((banner) => {
      banner.hidden = !cfg.freeVid || paid <= 0 || paid < (cfg.giftMin || cfg.t1);
    });
    patchCheckoutHrefs();
  }

  function patchCheckoutHrefs() {
    var code = typeof aphSaleDiscountCode === 'function' ? aphSaleDiscountCode() : '';
    if (code === 'PAYDAY3040') code = '';
    document.querySelectorAll('[data-aph-external-checkout], .aph-external-checkout').forEach(function (a) {
      if (!a || a.tagName !== 'A') return;
      var href = a.getAttribute('href') || '';
      if (href.indexOf('checkout.aphscience.com') === -1) return;
      try {
        var u = new URL(href, window.location.origin);
        if (code === 'PAYDAY30' || code === 'PAYDAY40') {
          u.searchParams.set('discount', code);
          u.searchParams.set('coupon', code);
          u.searchParams.set('coupon_code', code);
        } else {
          u.searchParams.delete('discount');
          u.searchParams.delete('coupon');
          u.searchParams.delete('coupon_code');
        }
        a.setAttribute('href', u.toString());
      } catch (e) {}
    });
  }

  function wipeTierExtras(box) {
    if (!box) return;
    box.querySelectorAll(
      '.aph-tier-row, .tier-row, .aph-tier-chip, .tier-chip, .aph-tier-tick, .aph-fomo-mark, .aph-fomo-bubble, .aph-fomo-label, .aph-morning-label, .aph-fomo-unlock, [data-fomo-unlock], .aph-fomo-head'
    ).forEach(function (n) {
      n.remove();
    });
    var track = box.querySelector('[data-tier-track]');
    if (track) {
      track.querySelectorAll('[data-fomo-mark], [data-tier-notch], .aph-morning-mark').forEach(function (n) {
        n.remove();
      });
    }
    box.querySelectorAll('[data-morning-captions], .aph-morning-captions').forEach(function (n) {
      n.remove();
    });
  }

  function ensureFomoMarks(box, cfg, paid) {
    var track = box.querySelector('[data-tier-track]');
    if (!track) return;
    wipeTierExtras(box);
    track = box.querySelector('[data-tier-track]');
    if (!track) return;
    var payday = cfg.preset === 'payday_30';
    var t1 = payday ? 5000 : cfg.t1;
    var t2 = payday ? 8000 : Math.max(1, cfg.t2 || 10000);
    var captions = payday
      ? [
          { i: 1, th: t1, left: (t1 / t2) * 100, text: '30% off ', gbp: t1, end: false },
          { i: 2, th: t2, left: 100, text: '40% off ', gbp: t2, end: true },
        ]
      : [{ i: 1, th: t2, left: 100, text: 'Free shipping ', gbp: t2, end: true }];
    var meter = box.querySelector('.aph-morning-meter') || track.parentNode;
    var caps = document.createElement('div');
    caps.className = 'aph-morning-captions';
    caps.setAttribute('data-morning-captions', '');
    captions.forEach(function (m) {
      if (payday || m.end) {
        var el = document.createElement('span');
        el.setAttribute('data-tier-notch', String(m.i));
        el.className = 'aph-morning-mark' + (m.end ? ' aph-morning-mark--end' : '');
        el.style.left = m.left.toFixed(2) + '%';
        var reached = paid >= m.th;
        el.classList.toggle('is-reached', reached);
        el.classList.toggle('reached', reached);
        track.appendChild(el);
      }
      var cap = document.createElement('span');
      cap.className = 'aph-morning-cap' + (m.end ? ' aph-morning-cap--end' : '');
      cap.setAttribute('data-cap', String(m.i));
      cap.innerHTML =
        m.text + '<b class="cur-price" data-gbp="' + (m.gbp / 100).toFixed(2) + '">' + moneyFromPence(m.gbp) + '</b>';
      caps.appendChild(cap);
    });
    if (meter) meter.appendChild(caps);
  }

  function updateOneTierBox(box, paid, cfg) {
    if (!box) return;
    var preset = cfg.preset || 'none';
    var payday = preset === 'payday_30';
    box.classList.add('aph-cart-shipping--morning');
    box.classList.remove('aph-cart-shipping--fomo');
    box.classList.toggle('aph-cart-shipping--payday', payday);
    box.classList.toggle('aph-cart-shipping--ship', preset === 'free_shipping');
    box.classList.toggle('is-sale-none', preset === 'none');
    box.setAttribute('data-preset', preset);
    box.setAttribute('data-sale-mode', aphSaleMode());
    box.setAttribute('data-sale-on', payday ? 'true' : 'false');
    paid = Math.max(0, parseInt(paid, 10) || 0);
    box.setAttribute('data-tier-paid', String(paid));
    box.setAttribute('data-sale-code', payday ? aphSaleDiscountCode() : '');
    if (typeof aphApplySaleHtml === 'function') aphApplySaleHtml();
    if (preset === 'none') {
      box.setAttribute('hidden', '');
      box.hidden = true;
      return;
    }
    box.removeAttribute('hidden');
    box.hidden = false;
    const t1 = payday ? 5000 : Math.max(1, parseInt(cfg.t1, 10) || 6500);
    const t2 = payday ? 8000 : Math.max(t1, parseInt(cfg.t2, 10) || 10000);
    const t3 = payday ? 8000 : Math.max(t2, parseInt(cfg.t3, 10) || 15000);
    function snapNear(target) {
      var gap = target - paid;
      return gap > 0 && gap < 10;
    }
    if (snapNear(t3)) paid = t3;
    else if (snapNear(t2)) paid = t2;
    else if (snapNear(t1)) paid = t1;
    const trackMax = t2;
    const pct = trackMax > 0 ? Math.min(100, (paid / trackMax) * 100) : 0;
    const fill = box.querySelector('[data-tier-fill], .aph-tier-fill, [data-ship-fill]');
    if (fill) fill.style.width = pct.toFixed(2) + '%';

    ensureFomoMarks(box, { preset: preset, t1: t1, t2: t2, t3: t3 }, paid);
    paintChipAmounts(box, { preset: preset, t1: t1, t2: t2, t3: t3 });

    var unlockedFirst = payday ? paid >= t1 : paid >= t2;
    var unlockedAll = paid >= t2;
    box.classList.toggle('is-tier-unlocked', unlockedFirst);
    box.classList.toggle('is-unlocked', unlockedAll);
    box.classList.toggle('unlocked', unlockedAll);

    box.querySelectorAll('[data-fomo-unlock], .aph-fomo-unlock').forEach(function (n) {
      n.remove();
    });

    function remainMoney(target) {
      var rem = target - paid;
      if (rem < 0) return 0;
      return rem;
    }

    const msg = box.querySelector('[data-cart-shipping-text]');
    if (msg) {
      msg.classList.remove('aph-fomo-head', 'aph-cart-alert', 'aph-cart-alert--ok', 'aph-cart-alert--info');
      if (payday) {
        if (paid < t1) {
          msg.innerHTML = 'Spend ' + moneyBFromPence(remainMoney(t1)) + ' more to unlock <span class="aph-payday-pct">30% off</span>';
        } else if (paid < t2) {
          msg.innerHTML = '<span class="aph-payday-pct">30% off unlocked</span>. Spend ' + moneyBFromPence(remainMoney(t2)) + ' more to unlock <span class="aph-payday-pct">40% off</span>';
        } else {
          msg.innerHTML = '<span class="aph-payday-pct">40% off unlocked</span>';
        }
      } else if (paid < t2) {
        msg.innerHTML = 'Spend ' + moneyBFromPence(remainMoney(t2)) + ' more to unlock free shipping';
      } else {
        msg.innerHTML = 'Unlocked - free shipping';
      }
    }

    /* Sachet thumb only while protein (£65) is the NEXT unlock (demos rule) */
    const sachet =
      box.querySelector('[data-cart-sachet-img], .aph-cart-sachet, .cart-shipping-sachet') ||
      box.querySelector('.aph-cart-shipping-msg img');
    if (sachet) {
      const showSachet = paid < t1;
      if (showSachet) {
        sachet.removeAttribute('hidden');
        sachet.hidden = false;
        sachet.style.display = '';
      } else {
        sachet.setAttribute('hidden', '');
        sachet.hidden = true;
      }
    }

    box.classList.toggle('is-unlocked', paid >= t2);
    box.classList.toggle('unlocked', paid >= t2);
    box.setAttribute('data-tier-paid', String(paid));
  }

  function updateSubtotalDisplay(cart) {
    const subEl = document.querySelector('.aph-cart-subtotal-value, [data-cart-subtotal]');
    if (!subEl) return;
    /* Prefer cart.js merchandise total (items_subtotal_price) minus free gifts */
    let paid = 0;
    if (cart && typeof cart.items_subtotal_price === 'number') {
      paid = paidSubtotal(cart);
      /* Sanity: if UI lines don't match, still trust paidSubtotal from items */
    } else if (cart) {
      paid = paidSubtotal(cart);
    } else {
      return;
    }
    const pounds = Math.max(0, paid) / 100;
    subEl.dataset.locked = '1';
    if (typeof window.APH !== 'undefined' && typeof window.APH.animatePrice === 'function') {
      window.APH.animatePrice(subEl, pounds);
    } else {
      subEl.setAttribute('data-gbp', pounds.toFixed(2));
      subEl.textContent = moneyFromPence(paid);
    }
  }

  function refreshDrawerSection() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer._fetchSection !== 'function') return Promise.resolve();
    return drawer._fetchSection('cart-drawer').then((html) => {
      if (!html) return;
      drawer._updating = true;
      drawer.classList.add('aph-cart-no-anim');
      var cart = window.__aphLastCart;
      if (!aphApplyCartDrawerHtml(drawer, html, cart) && cart && aphCartHasLines(cart)) {
        /* Keep live rows. Stale empty section HTML must not win. */
      } else if (typeof aphStripBulkWhenSale === 'function') {
        try { aphStripBulkWhenSale(cart); } catch (e2) {}
      }
      requestAnimationFrame(() => {
        drawer.classList.remove('aph-cart-no-anim');
        drawer._updating = false;
      });
    });
  }

  /* Harry 2026-08-17: gift-line removal only re-rendered the DRAWER
     (refreshDrawerSection above) - on the full /cart PAGE, cart/change.js
     correctly stripped the gift server-side but the page's own <cart-items>
     table was never told to re-render, so the "Unlocked - free with this
     order" row visually lingered until a manual reload. Mirror the same
     section-fetch-and-swap for the page's own cart-items element. */
  function refreshMainCartSection() {
    const cartItems = document.querySelector('cart-items:not(cart-drawer-items)');
    if (!cartItems) return Promise.resolve();
    return fetch(root() + 'cart?section_id=main-cart-items')
      .then((res) => res.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const source = html.querySelector('cart-items');
        if (source) cartItems.innerHTML = source.innerHTML;
      })
      .catch(() => {});
  }

  async function syncCartTiersAndGift(opts) {
    opts = opts || {};
    /* Harry 2026-08-08: "free sachet still unlocked after empty cart" -
       real gap here is a dropped update, not bad threshold math (the
       remove-below-t1 branch below is already correct). Two cart-changing
       events close together (e.g. removing the last real item right after
       a prior sync kicked off) used to just no-op the second call - the
       LATEST cart state was never re-checked, so a stale gift line could
       be left behind with nothing left to trigger its removal. Queue one
       trailing rerun instead of silently dropping it. */
    if (syncing) {
      pendingRerun = true;
      return;
    }
    syncing = true;
    try {
      const cartRes = await fetch(root() + 'cart.js', {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
      });
      if (!cartRes.ok) return;
      let cart = await cartRes.json();
      const cfg = readConfig();
      let paid = paidSubtotal(cart);
      updateTierDom(paid, cfg);
      updateSubtotalDisplay(cart);
      aphStripBulkWhenSale(cart);
      const drawerIcon = document.querySelector('cart-drawer');
      if (drawerIcon && typeof drawerIcon._updateCartIcon === 'function') {
        drawerIcon._updateCartIcon(null, cart);
      }

      const giftMin = typeof cfg.giftMin === 'number' && cfg.giftMin > 0 ? cfg.giftMin : cfg.t1;
      const hasPaidItems = paid > 0;
      let changed = false;
      async function stripGift(line) {
        if (!line || !line.key) return false;
        const changeRes = await fetch(root() + 'cart/change.js', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          credentials: 'same-origin',
          body: JSON.stringify({ id: line.key, quantity: 0 }),
        });
        return changeRes.ok;
      }
      const giftLines = (cart.items || []).filter(isGiftItem);

      /* Gift off, or paid £0 / no paid lines: never unlocked. Strip leftovers. */
      if (!cfg.freeVid || !hasPaidItems || paid < giftMin) {
        for (let i = 0; i < giftLines.length; i++) {
          if (await stripGift(giftLines[i])) changed = true;
        }
      } else {
        let giftLine = findGiftLine(cart);
        /* Stale *-gift / sachet vs the Cart-block product. */
        if (giftLine && String(giftLine.variant_id) !== String(cfg.freeVid)) {
          if (await stripGift(giftLine)) {
            changed = true;
            giftLine = null;
          }
        }
        if (!giftLine) {
          const addRes = await fetch(root() + 'cart/add.js', {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            credentials: 'same-origin',
            body: JSON.stringify({
              items: [
                {
                  id: Number(cfg.freeVid),
                  quantity: 1,
                  properties: {
                    _aph_gift: cfg.giftKind || 'free_protein',
                    _free_protein: 'true',
                  },
                },
              ],
            }),
          });
          if (addRes.ok) changed = true;
          else {
            try {
              const err = await addRes.json();
              console.warn('[APH] free gift add failed', err);
            } catch (e) {}
          }
        } else if (giftLine.quantity > 1) {
          const capRes = await fetch(root() + 'cart/change.js', {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            credentials: 'same-origin',
            body: JSON.stringify({ id: giftLine.key, quantity: 1 }),
          });
          if (capRes.ok) changed = true;
        }
      }

      /* Always re-render drawer AND /cart page when gift line changed
         (fromRender used to skip this) */
      if (changed) {
        await Promise.all([refreshDrawerSection(), refreshMainCartSection()]);
        const cart2 = await fetch(root() + 'cart.js', {
          headers: { Accept: 'application/json' },
          credentials: 'same-origin',
        }).then((r) => r.json());
        paid = paidSubtotal(cart2);
        updateTierDom(paid, readConfig());
        updateSubtotalDisplay(cart2);
        aphStripBulkWhenSale(cart2);
        const drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer._updateCartIcon === 'function') {
          drawer._updateCartIcon(null, cart2);
        }
        if (drawer) {
          var paidQty = aphPaidItemCount(cart2);
          drawer.classList.toggle('is-empty', paidQty === 0);
        }
      }
    } catch (e) {
      console.warn('[APH] cart tiers/gift', e);
    } finally {
      syncing = false;
      if (pendingRerun) {
        pendingRerun = false;
        syncCartTiersAndGift(opts).catch(() => {});
      }
    }
  }

  window.APH = window.APH || {};
  window.APH.syncCartTiersAndGift = syncCartTiersAndGift;
  window.APH.cartPaidSubtotal = function (cart) {
    return paidSubtotal(cart || { items: [] });
  };

  document.addEventListener('DOMContentLoaded', () => {
    if (typeof aphApplySaleHtml === 'function') aphApplySaleHtml();
    var strip =
      window.APH && typeof window.APH.stripBxgyZeroExtras === 'function'
        ? window.APH.stripBxgyZeroExtras()
        : Promise.resolve(false);
    Promise.resolve(strip)
      .then(function (changed) {
        if (changed && window.APH && typeof window.APH.refreshCartDom === 'function') {
          return window.APH.refreshCartDom();
        }
      })
      .then(() => syncCartTiersAndGift())
      .catch(() => syncCartTiersAndGift().catch(() => {}));
  });
  document.addEventListener('aph:currency', () => {
    var cfg = readConfig();
    document.querySelectorAll('[data-aph-cart-tiers]').forEach(function (box) {
      paintChipAmounts(box, cfg);
    });
  });

  document.addEventListener('cart:updated', () => {
    syncCartTiersAndGift().catch(() => {});
  });
  function aphResyncOnReturn(force) {
    if (window.APH && typeof window.APH.resyncCartFromServer === 'function') {
      window.APH.resyncCartFromServer({ force: !!force }).catch(function () {});
    }
  }
  window.addEventListener('pageshow', function (e) {
    if (e && e.persisted) window.APH._resyncInFlight = null;
    aphResyncOnReturn(true);
  });
  window.addEventListener('focus', function () {
    aphResyncOnReturn(true);
  });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') aphResyncOnReturn(true);
  });
  /* Harry 2026-08-13: "free gift stays in cart after removing items drops
     it back below threshold" - root cause found live (wrapped this
     function and counted calls): this subscription NEVER registered, so
     real add/remove/quantity-change actions never re-ran the gift check
     at all - only DOMContentLoaded and the drawer-open observer did.
     `window.PUB_SUB_EVENTS` is always undefined here: PUB_SUB_EVENTS is
     declared with const/let at the top of a classic (non-module) script,
     and top-level const/let bindings never attach to `window`, unlike var
     or plain function declarations (confirmed live: bare PUB_SUB_EVENTS
     resolves fine, window.PUB_SUB_EVENTS does not). The `subscribe` check
     right next to it correctly uses the bare identifier - this one just
     didn't match that pattern. */
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    try {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        setTimeout(() => syncCartTiersAndGift().catch(() => {}), 80);
      });
    } catch (e) {}
  }

  /* Sync once when drawer opens - not on every class mutation (avoids loops) */
  const obs = new MutationObserver(() => {
    const d = document.querySelector('cart-drawer');
    if (!d) return;
    const open = d.classList.contains('active') || d.hasAttribute('open');
    if (open && !lastOpen) {
      lastOpen = true;
      syncCartTiersAndGift().catch(() => {});
    } else if (!open) {
      lastOpen = false;
    }
  });
  if (document.documentElement) {
    obs.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class', 'open'],
      subtree: true,
    });
  }
})();
